import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-75d1e928")

_pushScopeId("data-v-75d1e928")
const _hoisted_1 = { class: "kn-overflow-y kn-flex p-d-flex p-flex-column" }
const _hoisted_2 = {
  key: 0,
  class: "p-d-flex p-flex-row p-flex-wrap kn-flex"
}
const _hoisted_3 = {
  key: 1,
  class: "kn-flex"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_WorkspaceFederationDatasetList = _resolveComponent("WorkspaceFederationDatasetList")
  const _component_WorkspaceFederationDefinitionAssociationsEditor = _resolveComponent("WorkspaceFederationDefinitionAssociationsEditor")
  const _component_WorkspaceFederationDefinitionAssociationsList = _resolveComponent("WorkspaceFederationDefinitionAssociationsList")
  const _component_WorskpaceFederationDatasetDialog = _resolveComponent("WorskpaceFederationDatasetDialog")
  const _component_WorkspaceFederationSaveDialog = _resolveComponent("WorkspaceFederationSaveDialog")
  const _component_WorkspaceWarningDialog = _resolveComponent("WorkspaceWarningDialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, {
      class: "kn-toolbar kn-toolbar--primary",
      style: _ctx.mainDescriptor.style.maxWidth
    }, {
      start: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('workspace.federationDefinition.title')), 1)
      ]),
      end: _withId(() => [
        _createVNode(_component_Button, {
          class: "kn-button p-button-text p-button-rounded federation-button",
          onClick: _ctx.changeSteps
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.step === 0 ? _ctx.$t('common.next') : _ctx.$t('common.back')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        (_ctx.step === 1)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              class: "kn-button p-button-text p-button-rounded federation-button p-mr-2",
              onClick: _ctx.saveFederation
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('workspace.federationDefinition.saveFederation')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        _createVNode(_component_Button, {
          class: "kn-button p-button-text p-button-rounded",
          onClick: _ctx.closeFederationDefinition
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["style"]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          mode: "indeterminate",
          class: "kn-progress-bar"
        }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_1, [
      (_ctx.step === 0)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _createVNode(_component_WorkspaceFederationDatasetList, {
              class: "kn-flex p-m-2",
              mode: 'available',
              propDatasets: _ctx.availableDatasets,
              onShowInfo: _ctx.showDatasetInfo,
              onDatasetSelected: _ctx.moveDataset
            }, null, 8, ["propDatasets", "onShowInfo", "onDatasetSelected"]),
            _createVNode(_component_WorkspaceFederationDatasetList, {
              class: "kn-flex p-m-2",
              mode: 'selected',
              propDatasets: _ctx.selectedDatasets,
              onDatasetSelected: _ctx.moveDataset
            }, null, 8, ["propDatasets", "onDatasetSelected"])
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode(_component_WorkspaceFederationDefinitionAssociationsEditor, {
              class: "p-m-2",
              selectedDatasets: _ctx.selectedDatasets,
              selectedMetafields: _ctx.selectedMetafields,
              resetSelectedMetafield: _ctx.resetSelectedMetafield
            }, null, 8, ["selectedDatasets", "selectedMetafields", "resetSelectedMetafield"]),
            _createVNode(_component_WorkspaceFederationDefinitionAssociationsList, {
              class: "p-m-2",
              propAssociations: _ctx.multirelationships,
              onCreateAssociationClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.createAssociation()))
            }, null, 8, ["propAssociations"])
          ])),
      _createVNode(_component_WorskpaceFederationDatasetDialog, {
        visible: _ctx.infoDialogVisible,
        dataset: _ctx.selectedDataset,
        onClose: _ctx.closeInfoDialog
      }, null, 8, ["visible", "dataset", "onClose"]),
      _createVNode(_component_WorkspaceFederationSaveDialog, {
        visible: _ctx.saveDialogVisible,
        federatedDataset: _ctx.federatedDataset,
        onClose: _ctx.closeSaveDialog,
        onSave: _ctx.handleSaveFederation
      }, null, 8, ["visible", "federatedDataset", "onClose", "onSave"]),
      _createVNode(_component_WorkspaceWarningDialog, {
        visible: _ctx.warningDialogVisbile,
        title: _ctx.$t('workspace.federationDefinition.title'),
        warningMessage: _ctx.warningMessage,
        onClose: _ctx.closeWarningDialog
      }, null, 8, ["visible", "title", "warningMessage", "onClose"])
    ])
  ], 64))
})